module.exports = __webpack_public_path__ + "static/media/photo311.84bff6cf.jpg";